var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"app-container"},[_c('TestRunner')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }